import { createReducer, on } from '@ngrx/store';
import { storeFilters } from '../actions/filter.action';
import { AppState } from '@app/types/app.types';
import * as AppActions from '../actions/app.actions';

export const initialState: AppState = {
  azureAccessToken: null,
  azureIdToken: null,
  profile: null,
  customerFilters: null,
  materialFilters: null,
};

export const appReducer = createReducer(
  initialState,
  on(AppActions.setProfile, (state, payload: any) => ({
    ...state,
    profile: payload?.profile || null, // Destructure filters from action payload and update state
  })),
  on(storeFilters, (state: any, filterData) => {
    return { ...state, customerFilters: [...filterData?.customerFilters], materialFilters: [...filterData?.materialFilters] };
  })
);
